import { Link } from "react-router-dom";

function SingleItem({ section }) {
  return (
    <Link to="/about/single" state={section} className="text-decoration-none">
      <div
        className="bg-wafaa-white-2 mx-3 rounded-2 py-1"
        style={{
          paddingInline: ".2rem",
          marginBlock: "1.2rem",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 6px rgba(0, 0, 0, 0.05)"
        }}
      >
        <p className="w-100 mx-auto border-1 mb-0 border-top-0 border-end-0 border-start-0 mb-0 p-2 font-size-14 d-flex justify-content-between font-weight-500">
          <span className="font-weight-bolder text-wafaa-black-1">
            {section?.Heading}
          </span>
          <span className="text-wafaa-grey">&gt;</span>
        </p>
      </div>
    </Link>
  );
}

export default SingleItem;
